<template>
  <BCard>
    <div class="text-black text-2xl font-medium mb-2">
      Data Partner
    </div>
    <hr>
    <BTabs
      v-model="tabIndex"
      class="mt-2"
      pills
      active-nav-item-class="rounded-pill"
      nav-class="mb-0"
    >
      <BTab
        title="Semua"
        active
        lazy
        title-item-class="bg-[#F8F8F8] mr-[24px] mb-[1rem] rounded-[25px]"
      >
        <All />
      </BTab>
      <BTab
        :active="$route.query.tab === 'risk_review'"
        lazy
        title-item-class="bg-[#F8F8F8] mr-[24px] mb-[1rem] rounded-[25px]"
        title="Risk Review"
      >
        <RiskReview />

      </BTab>
    </BTabs>
  </BCard>
</template>

<script>
import All from './All.vue'
import RiskReview from './RiskReview.vue'

export default {
  components: {
    All,
    RiskReview,
  },
  data() {
    return {
      tabs: ['all', 'risk_review'],
      tabIndex: 0,
    }
  },
  watch: {
    tabIndex(newTab) {
      const tab = this.tabs[newTab]
      if (this.$route.query.tab !== tab) this.$router.replace({ query: { tab } })
    },
  },
}
</script>
